<template>
  <div class="homepage__accordion" v-bind:class="{ '--expanded': isExpanded }">
    <div
      class="homepage__accordion__header media +pd-xs +border"
      @click="toggle"
    >
      <div class="media__figure icon +mg-none">
        <svg class="icon__glyph">
          <use
            xmlns:xlink="http://www.w3.org/1999/xlink"
            v-bind:xlink:href="icon"
          ></use>
        </svg>
      </div>
      <div class="media__body">
        <div class="media --reverse">
          <div class="media__figure icon --xs +mg-top-xxs">
            <svg class="icon__glyph homepage__accordion__arrow">
              <use
                xmlns:xlink="http://www.w3.org/1999/xlink"
                v-bind:xlink:href="arrow"
              ></use>
            </svg>
          </div>
          <div class="media__body">
            <slot name="title"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class="homepage__accordion__content-container">
      <transition name="expand">
        <div class="homepage__accordion__content" v-show="isExpanded">
          <slot name="body"></slot>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    arrow: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isExpanded: false
    }
  },
  created() {
    this.isExpanded = this.expanded
  },
  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded
    }
  }
}
</script>
